import { Quote } from 'lucide-react';
import AINetwork from '@/components/AINetwork';
import CTABand from '@/components/CTABand';
import { TESTIMONIALS } from '@/lib/content';
import { SECTION } from '@/lib/testIds';

const RESULTS = [
  { k: '3.2x', v: 'Avg. ROAS Lift', s: 'Across performance engagements' },
  { k: '47%', v: 'Shorter Lead → Opp Cycle', s: 'Driven by AI automation' },
  { k: '+38%', v: 'LTV Improvement', s: 'Via journey & lifecycle redesign' },
  { k: '2x', v: 'Pipeline Acceleration', s: 'In under 2 quarters' },
];

export default function TestimonialsPage() {
  return (
    <div>
      <section className="relative pt-32 pb-16 lg:pt-44 lg:pb-20 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-30" aria-hidden />
        <AINetwork density={26} />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-xs uppercase tracking-[0.22em] text-cyan-300/80 mb-5">Testimonials & Impact</div>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[1.02] tracking-tighter max-w-4xl text-balance">
            <span className="gradient-text">Outcomes</span> over output.
          </h1>
          <p className="mt-7 max-w-2xl text-lg text-white/70 leading-relaxed">
            What growth leaders, founders and CMOs say about partnering with SKV Digital Labs.
          </p>
        </div>
      </section>

      {/* Impact Numbers */}
      <section className="relative py-16 lg:py-20 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {RESULTS.map((r, i) => (
              <div key={i} className="rounded-2xl border border-white/10 bg-[#0B1221]/40 p-7">
                <div className="font-heading text-4xl sm:text-5xl font-semibold gradient-text-static">{r.k}</div>
                <div className="mt-3 font-medium text-sm">{r.v}</div>
                <div className="text-xs text-brand-ink mt-1">{r.s}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section data-testid={SECTION.testimonials} className="relative py-20 lg:py-24 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <div
                key={i}
                className={`relative rounded-2xl border border-white/10 bg-[#0B1221]/60 p-8 hover:border-cyan-400/30 transition-all ${
                  i % 3 === 0 ? 'md:translate-y-3' : ''
                }`}
              >
                <Quote className="w-7 h-7 text-cyan-300/60 mb-5" strokeWidth={1.5} />
                <p className="text-lg text-white/85 leading-relaxed text-balance">&ldquo;{t.quote}&rdquo;</p>
                <div className="mt-7 pt-5 border-t border-white/5 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400/30 to-purple-500/30 grid place-items-center font-heading font-semibold text-sm">
                    {t.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
                  </div>
                  <div>
                    <div className="font-medium text-sm">{t.name}</div>
                    <div className="text-xs text-brand-ink">{t.title} · {t.region}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABand title="Become the next growth story." ctaLabel="Book a Strategy Call" />
    </div>
  );
}
